/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of time locks */
export enum TimeLockType {
  Standard,
  Vesting,
  Emergency,
  Governance,
}

export type TimeLockTypeArgs = TimeLockType;

export function getTimeLockTypeEncoder(): FixedSizeEncoder<TimeLockTypeArgs> {
  return getEnumEncoder(TimeLockType);
}

export function getTimeLockTypeDecoder(): FixedSizeDecoder<TimeLockType> {
  return getEnumDecoder(TimeLockType);
}

export function getTimeLockTypeCodec(): FixedSizeCodec<
  TimeLockTypeArgs,
  TimeLockType
> {
  return combineCodec(getTimeLockTypeEncoder(), getTimeLockTypeDecoder());
}
